import * as React from 'react';
import { CustomButton, ButtonType, HiddenInput, Form, CustomSubmitButton } from "soprasteria-ui-library";
import { IRiskPotReportTreatment, IRiskPotAssessment, IRiskPotTreatmentAssessment } from '../../../models/IRiskPotReport';
import { isInRole, UserContext } from '../../../contexts/UserContext';
import { ALLMÄNTANDVÅRDBAS } from '../../../utils/RoleConstants';
import { SubmitAssessmentModal } from "./SubmitAssessmentModal";
import { RiskPotReportTreatmentsTable } from "./RiskPotReportTreatmentsTable";

interface IRiskPotReportTreatments {
    treatments: IRiskPotReportTreatment[];
    riskPotReportCanBeEdited: boolean;
    canReportTreatment: boolean;
    setShowTreatmentForm: React.Dispatch<React.SetStateAction<boolean>>;
    riskPotReportId: number;
    changeSuccessMessage: (message: string) => void;
    getRiskPotReport: () => void;
    canAssessTreatments: () => boolean;
    riskPotReportStartDate: Date;
    riskPotReportEndDate: Date;
    riskPotReportinvoicedAmount: number;
    getPreAssessment: (preAssessmentId: number) => void;
    activePreAssessmentDecisionComment?: string;
}

export const RiskPotReportTreatments: React.FunctionComponent<IRiskPotReportTreatments> = ({ treatments, riskPotReportCanBeEdited, canReportTreatment, setShowTreatmentForm, riskPotReportId, changeSuccessMessage, getRiskPotReport, canAssessTreatments, riskPotReportStartDate, riskPotReportEndDate, riskPotReportinvoicedAmount, getPreAssessment, activePreAssessmentDecisionComment }) => {

    const userInfo = React.useContext(UserContext);
    const hasRoleAllmanTandvard = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles);
    const [isCommentRequired, setIsCommentRequired] = React.useState<boolean>(false);
    const [riskPotExpandAmount, setRiskPotExpandAmount] = React.useState<number>(0);
    const [isApprovedWithReservation, setIsApprovedWithReservation] = React.useState<boolean | undefined>();
    const [assessedTreatments, setAssessedTreatments] = React.useState<IRiskPotTreatmentAssessment[]>([])

    const openSubmitAssessmentModal = (data: IRiskPotAssessment) => {
        
        var filteredTreatments = data.treatments.filter((treatment) => treatment != null);
        setAssessedTreatments(filteredTreatments);

        var approvedTreatments = filteredTreatments.filter((treatment) => String(treatment.isApproved) === "true");

        var isAllTreatmentsApproved = approvedTreatments.length === filteredTreatments.length;
        setIsCommentRequired(!isAllTreatmentsApproved);

        const riskPotExtpandAmount = calculateRiskPotExpandAmount(approvedTreatments.map((treatment) => { return treatment.patientTreatmentId }));
        setRiskPotExpandAmount(riskPotExtpandAmount);

        if (isAllTreatmentsApproved) {
            setIsApprovedWithReservation(undefined);
        }
        else {
            const isAllNotApproved = filteredTreatments.length - approvedTreatments.length == filteredTreatments.length;
            setIsApprovedWithReservation(!isAllNotApproved);
        }

        document.getElementById("open-submit-assessment-modal")?.click();
    }

    const calculateRiskPotExpandAmount = (approvedTreatmentsIds: number[]): number => {
        var approvedTreatments = treatments.filter((treatment) => approvedTreatmentsIds.some((id) => { return Number(id) === treatment.patientTreatmentId }))
        var expandAmount = 0;
        for (var i = 0; i < approvedTreatments.length; i++) {
            expandAmount += approvedTreatments[i].price * approvedTreatments[i].quantity;
        }

        return expandAmount
    }

    return (
        <>
            <div className="row panel">
                <div className="col-6 text-left">
                    <h5>Åtgärdskoder</h5>
                </div>
                {
                    riskPotReportCanBeEdited && hasRoleAllmanTandvard && canReportTreatment ?
                        <div className="col-6 text-right">
                            <CustomButton buttonText="Lägg till åtgärdskod" data-toggle="modal"
                                data-target="#add-risk-pot-report-treatment-modal" buttonType={ButtonType.create} onClick={() => setShowTreatmentForm(true)} />
                        </div>
                        : null
                }
            </div>
            {
                canAssessTreatments() ?
                    <>
                        <Form onSubmit={openSubmitAssessmentModal}>
                            <HiddenInput name="riskPotReportId" value={riskPotReportId.toString()} />
                            <RiskPotReportTreatmentsTable canAssessTreatments={canAssessTreatments} treatments={treatments} getRiskPotReport={getRiskPotReport} riskPotReportStartDate={riskPotReportStartDate} riskPotReportEndDate={riskPotReportEndDate} riskPotReportinvoicedAmount={riskPotReportinvoicedAmount} getPreAssessment={getPreAssessment} />
                            <div className="col-12 text-right">
                                <span className="invisible">
                                    <CustomButton buttonType={ButtonType.create} buttonText="" id="open-submit-assessment-modal" data-target="#submit-assessment-modal" data-toggle="modal" />
                                </span>
                                <CustomSubmitButton>Skicka beslut</CustomSubmitButton>
                            </div>
                        </Form>
                        <SubmitAssessmentModal
                            isCommentRequired={isCommentRequired}
                            getRiskPotReport={getRiskPotReport}
                            changeSuccessMessage={changeSuccessMessage}
                            setIsCommentRequired={setIsCommentRequired}
                            riskPotExpandAmount={riskPotExpandAmount}
                            isApprovedWithReservation={isApprovedWithReservation}
                            assessedTreatments={assessedTreatments}
                            riskPotReportId={riskPotReportId}
                            activePreAssessmentDecisionComment={activePreAssessmentDecisionComment}/>
                    </>
                    :
                    <RiskPotReportTreatmentsTable canAssessTreatments={canAssessTreatments} treatments={treatments} getRiskPotReport={getRiskPotReport} riskPotReportStartDate={riskPotReportStartDate} riskPotReportEndDate={riskPotReportEndDate} riskPotReportinvoicedAmount={riskPotReportinvoicedAmount} getPreAssessment={getPreAssessment} />
            }
        </>
    )
}

